module.exports = __webpack_public_path__ + "static/media/steak.fba54475.png";